module.exports = __webpack_public_path__ + "img/mind-header-fr.aa707500.png";